//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            headers: ['Vendor', 'Last Invoice #', { title: 'Last Invoice Date', filter: 'dateFull' }, 'Frequency', { title: 'Next Run Date', filter: 'dateFull' }, { title: 'Ends At', filter: 'dateFull' }, { title: 'Amount', filter: 'toCurrency' }],
            fields: ['vendor_name', 'last_invoice.number', 'last_invoice.invoice_date', 'frequency', 'next_run_date', 'ends_at', 'last_invoice.amount'],
            items: []
        };
    },
    created: function created() {
        var $el = this;
        Event.$on('remove-recurring-invoice', function (item, idx) {
            Event.$emit('confirm-delete', item, '/prototype/accounting/accounts-payable/invoice-recurring/' + item.id, 'delete-recurring-invoice', 'Are you sure you want to delete this invoice?', 'Delete', '', true);
        });
        Event.$on('delete-recurring-invoice', this.deleteRecurringInvoice);

        Event.$on('refresh-ap-recurring-invoices', function () {
            $el.load();
        });
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('remove-recurring-invoice');
        Event.$off('delete-recurring-invoice');
        Event.$off('refresh-ap-recurring-invoices');
    },

    methods: {
        deleteRecurringInvoice: function deleteRecurringInvoice(item) {
            var $el = this;
            this.$snotify.info('The invoice was deleted');
            var $idx = $el.items.findIndex(function (i) {
                return i.id === item.id;
            });
            $el.items.splice($idx, 1);
        },
        load: function load() {
            var $el = this;
            $el.items = [];

            axios.get('/prototype/accounting/accounts-payable/invoice-recurring').then(function (response) {
                $el.items = response.data;
                $el.items.map(function (item) {
                    if (item.last_invoice) {
                        item['vendor_name'] = item.last_invoice.vendor.name;
                    }
                });
                $el.loading = false;
            });
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/accounting/accounts-payable/invoices/RecurringInvoiceList.vue
// module id = lR2N
// module chunks = 0 1